import React from 'react';
import styled from 'styled-components';
import { isMobileOnly } from 'react-device-detect';
import { isEmpty } from 'lodash-es';
import moment from 'moment';
import {
  BaseBox,
  FlexBox,
  Heading3,
  Heading4,
} from '@docon/docon-ui-library';
import { borderColor } from 'utilities/colorConfig';

const Li = styled(Heading4).attrs(() => ({ tagAs: 'li' }))`
  list-style: disc;
  white-space: pre-line;
`;

const Row = styled(FlexBox)`
  padding: 16px 20px;
  gap: 16px;

  & + & {
    border-top: 1px solid ${borderColor};
  }

  ul { padding-left: 30px; }
`;

const Heading = styled(Heading3)`
  font-weight: 600;
`;

function processText(value: any, key: string) {

  switch (key) {
    case 'specialization':
    case 'service':
    case 'membership':
      return value;

    case 'education': {
      const { qual, college, year } = value || {};
      return `${qual || ''}, ${college || ''}, ${year || ''}`;
    }

    case 'experience': {
      const {
        startDate = '',
        endDate = '',
        role,
        hospitalName,
        city,
      } = value || {};
      let prefix = '';
      if (startDate)
        prefix = `${moment(startDate).format('MMM, YYYY')} - ${endDate ? moment(endDate).format('MMM, YYYY') : 'Present'}\n`;

      return `${prefix} ${role || ''} at ${hospitalName || ''}, ${city || ''}
      `;
    }

    case 'registration': {
      const { number, council, year } = value || {};
      return `${number || ''}, ${council || ''}, ${year || ''}`;
    }
  }
  return null;
}

function Item({
  isHidden,
  leftHeading,
  rightHeading,
  leftKey,
  rightKey,
  leftData = [],
  rightData = [],
}: any) {

  if (isHidden) return null;

  function renderLists(data: any, key: string) {
    return (
      <ul>
        {
          data.map((text: any, index: number) => (
            <Li key={index} title={processText(text, key)} />
          ))
        }
      </ul>
    );
  }

  return (
    <Row vertical={isMobileOnly} verticalSpace={0}>
      <BaseBox flex={1} hidden={!leftHeading}>
        <Heading title={leftHeading} />
        {renderLists(leftData, leftKey)}
      </BaseBox>
      <BaseBox flex={1} hidden={!rightHeading}>
        <Heading title={rightHeading} />
        {renderLists(rightData, rightKey)}
      </BaseBox>
    </Row>
  );
}

function About({
  doctors: {
    about = '',
    experienceYears = '',
    specializations = [],
    degrees = [],
    experiences = [],
    services = [],
    memberships = [],
    registrations = [],
  } = {},
}: any) {

  return (
    <>
      {
        about ? (
          <Row>
            <Heading4 title={about} />
          </Row>

        ) : null
      }

      <Item
        key={'specialization'}
        isHidden={isEmpty(specializations) && isEmpty(degrees)}
        leftHeading={isEmpty(specializations) ? '' : 'Specializations'}
        rightHeading={isEmpty(degrees) ? '' : 'Education'}
        leftKey={'specialization'}
        rightKey={'education'}
        leftData={specializations}
        rightData={degrees}
      />

      <Item
        key={'experience'}
        isHidden={isEmpty(experiences) && isEmpty(services)}
        leftHeading={isEmpty(experiences) ? '' : `Experience (${experienceYears || ''} years)`}
        rightHeading={isEmpty(services) ? '' : 'Services'}
        leftKey={'experience'}
        rightKey={'service'}
        leftData={experiences}
        rightData={services}
      />

      <Item
        key={'membership'}
        isHidden={isEmpty(memberships) && isEmpty(registrations)}
        leftHeading={isEmpty(memberships) ? '' : 'Memberships'}
        rightHeading={isEmpty(registrations) ? '' : 'Registrations'}
        leftKey={'membership'}
        rightKey={'registration'}
        leftData={memberships}
        rightData={registrations}
      />
    </>
  );
}
export default About;